/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/media-has-caption */
import Close from 'components/common/Close/Close';
import Input from 'components/common/Input/Input';
import cn from 'classnames';
import {
  useClickOutside,
  useForm,
  useIsMobile,
  useNavigation,
  useTextInputProps,
  useToast,
  useValidation
} from 'hooks';
import Select from 'react-select';
import { func } from 'prop-types';
import React, { useEffect, useRef, useState, useCallback } from 'react';
import { white, black40 } from 'styles/common/_constants.scss';
import { CrownIcon } from 'components/icons';
import { defineMessages, useIntl } from 'react-intl';
import { episodeValidation, ValidationMessages } from 'utils/constraints';
import Button from 'components/common/Button/Button';
import { convertDateFormat, getTodayDate, timeExtract } from 'utils/date';
import { useDispatch, useSelector } from 'react-redux';
import { addEpisode, getVideoUrlForJWPlayer, updateEpisode } from 'state/actions/episodesActions';
import { ERROR, SUCCESS, useStatus } from '@rootstrap/redux-tools';
import { some } from 'lodash';
import { contentOptions, videoUploadsType } from 'constants/constants';
import { handleDateKeyDown, routeWithProps, validateVideo, log } from 'utils/helpers';
import { ValidationErrors } from 'utils/validationErrors';
import { customDropDownStyles } from 'styles/customDropDownStyles';
import { routesPaths } from 'constants/routesPaths';
import UserService from 'services/userService';
import SeriesService from 'services/seriesService';
import parseError from 'utils/parseError';

const FIELDS = {
  title: 'title',
  description: 'description',
  creditsStartTime: 'creditsStartTime',
  membersPrice: 'membersPrice',
  nonMembersPrice: 'nonMembersPrice',
  seriesVideo: 'seriesVideo',
  lead_cast: 'lead_cast',
  credits: 'credits',
  content_viewer_category: 'content_viewer_category',
  notify_subscribers: 'notify_subscribers',
  earlyReleaseDate: 'earlyReleaseDate',
  earlyReleaseTime: 'earlyReleaseTime',
  releaseDate: 'releaseDate',
  releaseTime: 'releaseTime'
};

// Helper function to format seconds to HH:MM:SS format and also return raw seconds
const formatSecondsToTime = seconds => {
  if (!seconds || isNaN(seconds)) return { formatted: '00:00:00', seconds: 0 };
  
  const secondsInt = Math.floor(seconds);
  const hours = Math.floor(secondsInt / 3600);
  const minutes = Math.floor((secondsInt % 3600) / 60);
  const secs = Math.floor(secondsInt % 60);
  
  const formatted = [
    hours.toString().padStart(2, '0'),
    minutes.toString().padStart(2, '0'),
    secs.toString().padStart(2, '0')
  ].join(':');
  
  return { formatted, seconds: secondsInt };
};

// Helper function for large files that cannot be processed with createObjectURL
// This uses metadata extraction methods that work with chunks instead of loading the whole file
const getVideoDurationFromFile = file => {
  return new Promise((resolve, reject) => {
    // Validate file object first
    if (!file || typeof file !== 'object') {
      log('error', 'Invalid file object passed to getVideoDurationFromFile', { file });
      resolve({ formatted: '00:00:00', seconds: 0 });
      return;
    }

    // For files larger than 10GB, we'll use a chunked approach
    if (file.size > 10 * 1024 * 1024 * 1024) {
      log('info', 'Using chunked metadata extraction for large file', { 
        fileName: file.name, 
        fileSize: file.size 
      });
      
      // Use MediaInfo.js or similar library for large files
      // This is a placeholder - we'll just estimate for now based on file size and type
      // Rough estimate: ~1 hour per 4GB for high quality video
      const estimatedDurationSeconds = Math.floor((file.size / (4 * 1024 * 1024 * 1024)) * 3600);
      const durationObj = formatSecondsToTime(estimatedDurationSeconds);
      
      log('info', 'Using estimated duration for large file', { 
        estimatedDurationSeconds,
        formattedTime: durationObj.formatted
      });
      resolve(durationObj);
    } else {
      // For smaller files, use the standard HTML5 approach
      try {
        const video = document.createElement('video');
        video.preload = 'metadata';
        
        video.onloadedmetadata = () => {
          try {
            window.URL.revokeObjectURL(video.src);
            const durationSeconds = video.duration;
            const durationObj = formatSecondsToTime(durationSeconds);
            
            log('info', 'Retrieved video duration', { 
              fileName: file.name, 
              durationSeconds,
              formattedTime: durationObj.formatted
            });
            resolve(durationObj);
          } catch (error) {
            log('error', 'Error processing video metadata', { error: error.message });
            resolve({ formatted: '00:00:00', seconds: 0 });
          }
        };
        
        video.onerror = e => {
          log('error', 'Error loading video', { 
            fileName: file.name,
            error: e.target.error
          });
          // Fallback to a default duration if metadata cannot be extracted
          resolve({ formatted: '00:00:00', seconds: 0 });
        };
        
        // Make sure file is valid before creating object URL
        if (file instanceof Blob) {
          video.src = URL.createObjectURL(file);
        } else {
          log('error', 'File is not a Blob, cannot create object URL', { 
            fileType: typeof file,
            isBlob: file instanceof Blob
          });
          resolve({ formatted: '00:00:00', seconds: 0 });
        }
      } catch (error) {
        log('error', 'Error in video duration extraction', { error: error.message });
        resolve({ formatted: '00:00:00', seconds: 0 });
      }
    }
  });
};

const messages = defineMessages({
  description: { id: 'form.description' },
  descriptionPlaceholder: { id: 'form.descriptionPlaceholder' },
  title: { id: 'form.title' },
  titlePlaceholder: { id: 'form.titlePlaceholder' },
  logo: { id: 'form.logo' },
  uploadLogo: { id: 'form.uploadLogo' },
  trailer: { id: 'form.trailer' },
  uploadTrailer: { id: 'form.uploadTrailer' },
  cover: { id: 'form.cover' },
  uploadCover: { id: 'form.uploadCover' },
  coverMobile: { id: 'form.coverMobile' },
  uploadCoverMobile: { id: 'form.uploadCoverMobile' },
  categories: { id: 'form.categories' },
  addBtn: { id: 'form.add' },
  shareTo: { id: 'form.shareTo' },
  episodes: { id: 'label.episodes' },
  addEpisode: { id: 'btn.addEpisode' },
  newEpisode: { id: 'form.newEpisode' },
  video: { id: 'form.video' },
  nameYourEpisodePlaceholder: { id: 'title.nameYourEpisodePlaceholder' },
  descriptionEpisodePlaceholder: { id: 'form.descriptionEpisodePlaceholder' },
  creditStartTime: { id: 'form.creditStartTime' },
  hhmmssPlaceholder: { id: 'form.hhmmssPlaceholder' },
  date: { id: 'form.date' },
  time: { id: 'form.time' },
  releaseDateTimeLabel: { id: 'form.releaseDateTimeLabel' },
  setPriceLabel: { id: 'form.setPriceLabel' },
  nonMembers: { id: 'form.nonMembers' },
  members: { id: 'form.members' },
  chooseVideo: { id: 'form.chooseVideo' },
  earlyReleaseMembers: { id: 'form.earlyReleaseMembers' },
  normalRelease: { id: 'form.normalRelease' }
});

const AddEpisodeForm = ({ hide, id, handleClose, editEpisodeData, seriesId }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { goTo } = useNavigation();
  const ref = useClickOutside(hide, id);
  const username = useRef();
  const isMobile = useIsMobile();
  const [exclusive, setExclusive] = useState(false);
  const seriesVideoRef = useRef(null);
  const [selectedContent, setSelectedContent] = useState([]);
  const [seriesVideo, setSeriesVideo] = useState(null);
  const [creditStartTime, setCreditStartTime] = useState('');
  const [releaseTime, setReleaseTime] = useState('');
  const [earlyReleaseTime, setEarlyReleaseTime] = useState('');
  const [membersPrice, setMembersPrice] = useState('');
  const [nonMembersP, setNonMembersP] = useState('');
  const { error, status } = useStatus(getVideoUrlForJWPlayer);
  const { error: updateEpisodeError, status: updateEpisodeStatus } = useStatus(updateEpisode);
  const { episode } = useSelector(({ episodes: { episode } }) => ({ episode }));
  const { showErrorToast, showToast } = useToast();
  const [subscribedFans, setSubScribedFans] = useState(true);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [videoDuration, setVideoDuration] = useState('00:00:00');
  const [formErrors, setFormErrors] = useState({});

  const getProfile = async () => {
    try {
      const { data } = await UserService.getProfile();
      username.current = data.user.username;
    } catch ({ response }) {
      throw parseError(response);
    }
  };

  useEffect(() => {
    if (editEpisodeData !== null) {
      getProfile();
    }
  }, []);

  useEffect(() => {
    if (status === SUCCESS) {
      dispatch(addEpisode(episode));
      dispatch(getVideoUrlForJWPlayer.reset());
      handleClose();
    }
    if (status === ERROR) {
      showErrorToast(error);
      dispatch(getVideoUrlForJWPlayer.reset());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  const handleChecked = event => {
    setExclusive(event.currentTarget.checked);
  };

  const validator = useValidation(episodeValidation);

  useEffect(() => {
    if (updateEpisodeStatus === SUCCESS) {
      showToast('Episode Updated Successfully!');
      dispatch(updateEpisode.reset());
      goTo(
        routeWithProps(routesPaths.celebrityId, {
          username: username.current.toLowerCase()
        })
      );
    }
    if (updateEpisodeStatus === ERROR) {
      showErrorToast(updateEpisodeError);
      dispatch(updateEpisode.reset());
    }
  }, [updateEpisodeStatus]);

  const onSubmit = async values => {
    if (editEpisodeData !== null) {
      const { position, episodeId } = editEpisodeData;
      const updatedEpisode = {
        ...values,
        leadCast: values.lead_cast,
        contentViewerCategory: values.content_viewer_category,
        viewer_category: values.content_viewer_category,
        viewerCategory: values.content_viewer_category,
        credits: values.credits,
        earlyReleaseDateTime: exclusive
          ? undefined
          : values[FIELDS.earlyReleaseDate]
          ? convertDateFormat(
              `${values[FIELDS.earlyReleaseDate]} ${values[FIELDS.earlyReleaseTime]}`
            )
          : undefined,
        releaseDateTime: values[FIELDS.releaseDate]
          ? convertDateFormat(`${values[FIELDS.releaseDate]} ${values[FIELDS.releaseTime]}`)
          : undefined,
        membersPrice: membersPrice.replace('$', ''),
        nonMembersPrice: nonMembersP.replace('$', ''),
        creditsStartTime: creditStartTime || '',
        exclusive,
        seriesVideo,
        duration: typeof seriesVideo?.duration === 'number' ? seriesVideo.duration : 0
      };

      // Extract position and episodeId to avoid duplicate values in the body
      dispatch(
        updateEpisode({
          seriesId,
          episodeId,
          position,
          ...updatedEpisode
        })
      );
    } else {
      values.earlyReleaseDateTime = exclusive
        ? undefined
        : values[FIELDS.earlyReleaseDate]
        ? convertDateFormat(`${values[FIELDS.earlyReleaseDate]} ${values[FIELDS.earlyReleaseTime]}`)
        : undefined;
      values.releaseDateTime = values[FIELDS.releaseDate]
        ? convertDateFormat(`${values[FIELDS.releaseDate]} ${values[FIELDS.releaseTime]}`)
        : undefined;
      values.seriesVideo = seriesVideo;
      values.creditStartTime = creditStartTime || null;
      values.duration = typeof seriesVideo?.duration === 'number' ? seriesVideo.duration : 0;

      try {
        // Only set uploading state if we're doing a regular upload
        // if (!seriesVideo?.isMultipart) {
        setIsUploading(true);
        await dispatch(getVideoUrlForJWPlayer({ ...values, exclusive }));
        // } else {
        //   // For multipart uploads, we already have the media_id and uploadId
        //   dispatch(addEpisode({ ...values, exclusive }));
        //   handleClose();
        // }
      } catch (error) {
        showErrorToast(`Failed to upload video: ${error.message}`);
        setIsUploading(false);
      }
    }
  };

  const { values, errors, handleValueChange, handleBlur, handleSubmit, setValues, setErrors } = useForm(
    {
      onSubmit,
      validator,
      validateOnBlur: true,
      validateOnChange: true,
      initialValues: {
        membersPrice: ' ',
        nonMembersPrice: ' ',
        notify_subscribers: true,
        [FIELDS.earlyReleaseDate]: '',
        [FIELDS.earlyReleaseTime]: '',
        [FIELDS.releaseDate]: '',
        [FIELDS.releaseTime]: '',
        [FIELDS.creditsStartTime]: ''
      }
    },
    [onSubmit]
  );

  useEffect(() => {
    if (editEpisodeData !== null) {
      setValues({
        ...editEpisodeData,
        [FIELDS.lead_cast]: editEpisodeData.leadCast,
        [FIELDS.nonMembersPrice]: !editEpisodeData.exclusive
          ? editEpisodeData.nonMembersPrice
          : null,
        [FIELDS.earlyReleaseDate]: editEpisodeData.earlyReleaseDateTime
          ? new Date(editEpisodeData.earlyReleaseDateTime).toISOString().split('T')[0]
          : null,
        [FIELDS.earlyReleaseTime]: editEpisodeData.earlyReleaseDateTime
          ? timeExtract(editEpisodeData.earlyReleaseDateTime)
          : null,
        [FIELDS.releaseDate]: editEpisodeData.releaseDateTime
          ? new Date(editEpisodeData.releaseDateTime).toISOString().split('T')[0]
          : null,
        [FIELDS.releaseTime]: editEpisodeData.releaseDateTime
          ? timeExtract(editEpisodeData.releaseDateTime)
          : null,
        [FIELDS.creditsStartTime]:
          editEpisodeData.credits_start_time !== '' ? editEpisodeData.credits_start_time : null
      });
      const selectedContent = contentOptions.filter(
        item => item.value === editEpisodeData.contentViewerCategory
      );
      setCreditStartTime(
        editEpisodeData?.creditsStartTime ? editEpisodeData?.creditsStartTime : ''
      );
      setReleaseTime(
        editEpisodeData.releaseDateTime ? timeExtract(editEpisodeData.releaseDateTime) : ''
      );
      setEarlyReleaseTime(
        editEpisodeData.earlyReleaseDateTime
          ? timeExtract(editEpisodeData.earlyReleaseDateTime)
          : ''
      );
      setSelectedContent(selectedContent[0]);
      setMembersPrice(editEpisodeData.membersPrice ? `$${editEpisodeData.membersPrice}` : '');
      setExclusive(editEpisodeData.exclusive);
      setSeriesVideo(editEpisodeData.link);
      if (!editEpisodeData.exclusive) {
        setNonMembersP(
          editEpisodeData.nonMembersPrice ? `$${editEpisodeData.nonMembersPrice}` : ''
        );
      }
    }
  }, [editEpisodeData, setValues]);

  const handleSeriesVideoUpload = () => {
    seriesVideoRef.current.click();
  };

  const resetSeriesVideoInput = () => {
    if (seriesVideoRef.current) {
      seriesVideoRef.current.value = '';
    }
  };

  const handleSeriesVideoChange = async e => {
    const file = e.target.files[0];
    if (!file) {
      log('error', 'No file selected');
      return;
    }

    if (file && file.type.startsWith('video/')) {
      try {
        // Check for quicktime files and create a modified file object with .mp4 extension
        let processedFile = file;
        if (
          file.type === 'video/quicktime' ||
          file.name.toLowerCase().endsWith('.quicktime') ||
          file.name.toLowerCase().endsWith('.qt')
        ) {
          // Create a new file object with .mp4 extension instead of .quicktime/.qt
          const newName = file.name.replace(/\.(quicktime|qt)$/i, '.mp4');
          processedFile = new File([file], newName, { type: 'video/mp4' });
        }

        const {
          isValid,
          isResolutionValid,
          isResolutionTooHigh,
          isAspectRatioValid,
          isFileSizeValid,
          error,
          videoInfo
        } = await validateVideo(processedFile, videoUploadsType.Movies);

        if (error) {
          showErrorToast(ValidationErrors.loadingVideo);
          resetSeriesVideoInput();
          return;
        } 
        
        if (!isFileSizeValid) {
          showErrorToast(ValidationErrors.fileSizeValidation);
          resetSeriesVideoInput();
          return;
        }
        
        if (!isResolutionValid) {
          showErrorToast(ValidationErrors.resolutionValidation);
          resetSeriesVideoInput();
          return;
        } 
        
        if (isResolutionTooHigh) {
          showErrorToast(ValidationErrors.resolutionTooHighValidation);
          resetSeriesVideoInput();
          return;
        }
        
        if (!isAspectRatioValid) {
          showErrorToast(ValidationErrors.aspectRatioValidationForMovies);
          resetSeriesVideoInput();
          return;
        }
        
        if (isValid) {
          // Extract and set the duration
          try {
            // Use duration from validateVideo if available
            let durationSeconds = 0;
            let durationFormatted = '00:00:00';
            
            if (videoInfo && videoInfo.duration) {
              const durationObj = formatSecondsToTime(videoInfo.duration);
              durationSeconds = durationObj.seconds;
              durationFormatted = durationObj.formatted;
              log('info', 'Using duration from validateVideo', { durationSeconds, durationFormatted });
            } else {
              // If not available, get it directly
              log('info', 'Getting duration directly from file', { fileName: processedFile.name });
              const durationObj = await getVideoDurationFromFile(processedFile);
              durationSeconds = durationObj.seconds;
              durationFormatted = durationObj.formatted;
            }
            
            log('info', 'Setting video duration', { 
              fileName: processedFile.name, 
              durationSeconds,
              durationFormatted
            });
            setVideoDuration(durationFormatted);
            
            // Check if file qualifies for multipart upload
            const MULTIPART_UPLOAD_THRESHOLD = 100 * 1024 * 1024; // 100MB threshold

            if (processedFile.size >= MULTIPART_UPLOAD_THRESHOLD) {
              try {
                log('info', 'Starting multipart upload initialization', { 
                  fileName: processedFile.name, 
                  fileSize: processedFile.size,
                  durationSeconds,
                  durationFormatted
                });
                setIsUploading(true);
                // Create multipart upload with mime type
                const { data } = await SeriesService.createMultipartUpload(processedFile.name, processedFile.type);
                const { uploadId, key: mediaId } = data;

                // Store multipart upload info in the episode object
                const multipartVideo = {
                  name: processedFile.name,
                  size: processedFile.size,
                  type: processedFile.type,
                  isMultipart: true,
                  uploadId,
                  mediaId,
                  originalFile: processedFile,
                  duration: durationSeconds, // Store as integer seconds
                  durationFormatted // Keep formatted version for display
                };

                log('info', 'Multipart upload initialized successfully', { 
                  uploadId, 
                  mediaId,
                  durationSeconds,
                  durationFormatted
                });
                setSeriesVideo(multipartVideo);
                handleValueChange(FIELDS.seriesVideo, multipartVideo);
                setIsUploading(false);
              } catch (error) {
                log('error', 'Failed to initialize multipart upload', {}, error);
                showErrorToast('Failed to initialize multipart upload');
                resetSeriesVideoInput();
                setIsUploading(false);
              }
            } else {
              log('info', 'Standard video upload', { 
                fileName: processedFile.name, 
                fileSize: processedFile.size,
                durationSeconds,
                durationFormatted
              });
              
              // Add duration to the file object
              const videoWithDuration = {
                name: processedFile.name,
                size: processedFile.size,
                type: processedFile.type,
                originalFile: processedFile,
                duration: durationSeconds, // Store as integer seconds
                durationFormatted // Keep formatted version for display
              };
              
              setSeriesVideo(videoWithDuration);
              handleValueChange(FIELDS.seriesVideo, videoWithDuration);
            }
          } catch (durationError) {
            log('error', 'Error getting video duration, using default', { error: durationError });
            // Continue even if we can't get the duration
            setVideoDuration('00:00:00');
            
            // Continue with the upload process without duration
            if (processedFile.size >= MULTIPART_UPLOAD_THRESHOLD) {
              // Create multipart upload
              try {
                log('info', 'Starting multipart upload with default duration', {
                  fileName: processedFile.name,
                  fileSize: processedFile.size
                });
                setIsUploading(true);
                const { data } = await SeriesService.createMultipartUpload(processedFile.name, processedFile.type);
                const { uploadId, key: mediaId } = data;
                
                const multipartVideo = {
                  name: processedFile.name,
                  size: processedFile.size,
                  type: processedFile.type,
                  isMultipart: true,
                  uploadId,
                  mediaId,
                  originalFile: processedFile,
                  duration: 0, // Use 0 for duration in seconds when we can't determine it
                  durationFormatted: '00:00:00'
                };
                
                setSeriesVideo(multipartVideo);
                handleValueChange(FIELDS.seriesVideo, multipartVideo);
                setIsUploading(false);
              } catch (error) {
                log('error', 'Failed to initialize multipart upload (fallback)', {}, error);
                showErrorToast('Failed to initialize multipart upload');
                resetSeriesVideoInput();
                setIsUploading(false);
              }
            } else {
              // Regular upload with default duration
              const videoWithDefaultDuration = {
                name: processedFile.name,
                size: processedFile.size,
                type: processedFile.type,
                originalFile: processedFile,
                duration: 0, // Use 0 for duration in seconds when we can't determine it
                durationFormatted: '00:00:00'
              };
              
              setSeriesVideo(videoWithDefaultDuration);
              handleValueChange(FIELDS.seriesVideo, videoWithDefaultDuration);
            }
          }
        }
      } catch (validationError) {
        log('error', 'Video validation failed', { error: validationError });
        showErrorToast(ValidationErrors.validFile);
        resetSeriesVideoInput();
      }
    } else {
      log('error', 'Invalid file type', { fileType: file?.type });
      showErrorToast(ValidationErrors.validFile);
      resetSeriesVideoInput();
    }
  };

  const inputProps = useTextInputProps(handleValueChange, handleBlur, values);
  const nonMembersPrice = !editEpisodeData && values[FIELDS.nonMembersPrice];

  const handleEarlyReleaseDate = e => {
    handleValueChange(FIELDS.earlyReleaseDate, e.target.value);
  };

  const handleReleaseDate = e => {
    handleValueChange(FIELDS.releaseDate, e.target.value);
  };

  const handleClearReleaseDateTime = () => {
    setValues(prev => ({
      ...prev,
      [FIELDS.releaseDate]: '',
      [FIELDS.releaseTime]: ''
    }));
    setReleaseTime('');
  };

  const handleClearEarlyReleaseDateTime = () => {
    setValues(prev => ({
      ...prev,
      [FIELDS.earlyReleaseDate]: '',
      [FIELDS.earlyReleaseTime]: ''
    }));
    setEarlyReleaseTime('');
  };

  const onChangeReleaseTime = event => {
    let value = event.target.value.replace(/[^0-9]/g, '');
    if (value.length > 2) {
      value = `${value.slice(0, 2)}:${value.slice(2)}`;
    }
    handleValueChange(FIELDS.releaseTime, value);
    setReleaseTime(value);
  };

  const onChangeEarlyReleaseTime = event => {
    let value = event.target.value.replace(/[^0-9]/g, '');
    if (value.length > 2) {
      value = `${value.slice(0, 2)}:${value.slice(2)}`;
    }
    handleValueChange(FIELDS.earlyReleaseTime, value);
    setEarlyReleaseTime(value);
  };

  const onChangeCreditsStartTime = event => {
    let value = event.target.value.replace(/[^0-9]/g, '');
    if (value.length > 2) {
      value = `${value.slice(0, 2)}:${value.slice(2)}`;
    }
    if (value.length > 5) {
      value = `${value.slice(0, 5)}:${value.slice(5, 7)}`;
    }
    setCreditStartTime(value);
  };

  const onChangeMembersPrice = event => {
    let value = event.target.value.replace(/[^0-9.]/g, '');
    if (value.length > 0) {
      value = `$${value}`;
      const valueWithoutDollar = value.slice(1);
      handleValueChange(FIELDS.membersPrice, valueWithoutDollar);
      setMembersPrice(value);

      // Validate member price min/max limits
      const memberValue = parseFloat(valueWithoutDollar);
      if (!isNaN(memberValue)) {
        if (memberValue > 0 && memberValue < 0.5) {
          setFormError(FIELDS.membersPrice, ValidationMessages.MIN_PRICE);
        } else if (memberValue >= 1000) {
          setFormError(FIELDS.membersPrice, ValidationMessages.MAX_PRICE);
        } else {
          setFormError(FIELDS.membersPrice, undefined);
        }
      }

      // If this is not exclusive content, check for non-member price validation
      if (!exclusive) {
        // Check if non-member price has min/max validation errors before overriding
        const nonMemberValue = nonMembersP ? parseFloat(nonMembersP.replace('$', '')) : 0;
        let preserveNonMemberError = false;
        
        if (!isNaN(nonMemberValue)) {
          if ((nonMemberValue > 0 && nonMemberValue < 0.5) || nonMemberValue >= 1000) {
            // Preserve existing min/max validation errors
            preserveNonMemberError = true;
          }
        }
        
        // Only update non-member price relationship error if there's no min/max error
        if (!preserveNonMemberError) {
          if (!nonMembersP || nonMembersP === '$' || nonMembersP === '$0') {
            setFormError(FIELDS.nonMembersPrice, ValidationMessages.NON_MEMBER_PRICE_LOWER);
          } else {
            if (!isNaN(nonMemberValue) && !isNaN(memberValue) && nonMemberValue < memberValue) {
              setFormError(FIELDS.nonMembersPrice, ValidationMessages.NON_MEMBER_PRICE_LOWER);
            } else {
              setFormError(FIELDS.nonMembersPrice, undefined);
            }
          }
        }
      }
    } else {
      // When clearing member price, also clear error and trigger re-render
      setMembersPrice('');
      handleValueChange(FIELDS.membersPrice, '');
      
      // Explicitly clear all validation errors for both fields
      setFormError(FIELDS.membersPrice, undefined);
      
      // Check if non-member price has min/max validation errors before clearing
      if (!exclusive) {
        const nonMemberValue = nonMembersP ? parseFloat(nonMembersP.replace('$', '')) : 0;
        let preserveNonMemberError = false;
        
        if (!isNaN(nonMemberValue)) {
          if ((nonMemberValue > 0 && nonMemberValue < 0.5) || nonMemberValue >= 1000) {
            // Preserve existing min/max validation errors
            preserveNonMemberError = true;
          }
        }
        
        // Only clear non-member price error if there's no min/max error
        if (!preserveNonMemberError) {
          setFormError(FIELDS.nonMembersPrice, undefined);
        }
      } else {
        setFormError(FIELDS.nonMembersPrice, undefined);
      }
      
      // Also clear errors in the useForm validation system
      setErrors(prev => ({
        ...prev,
        [FIELDS.membersPrice]: undefined,
        [FIELDS.nonMembersPrice]: undefined
      }));
      
      // Force re-render of nonMembersPrice by setting the same value
      if (nonMembersP) {
        // This will trigger a re-render of the nonMembersPrice Input
        setNonMembersP(nonMembersP);
      }
    }
  };

  const onChangeNonMembersPrice = event => {
    let value = event.target.value.replace(/[^0-9.]/g, '');
    if (value.length > 0) {
      value = `$${value}`;
      const valueWithoutDollar = value.slice(1);
      handleValueChange(FIELDS.nonMembersPrice, valueWithoutDollar);
      setNonMembersP(value);

      // Validate non-member price min/max limits
      const nonMemberValue = parseFloat(valueWithoutDollar);
      if (!isNaN(nonMemberValue)) {
        if (nonMemberValue > 0 && nonMemberValue < 0.5) {
          setFormError(FIELDS.nonMembersPrice, ValidationMessages.MIN_PRICE);
          return;
        } else if (nonMemberValue >= 1000) {
          setFormError(FIELDS.nonMembersPrice, ValidationMessages.MAX_PRICE);
          return;
        }
      }

      // Validate price relationship - use only formErrors for price validation
      if (membersPrice && membersPrice !== '$' && !exclusive) {
        const memberValue = parseFloat(membersPrice.replace('$', ''));
        
        if (!isNaN(nonMemberValue) && !isNaN(memberValue) && nonMemberValue < memberValue) {
          setFormError(FIELDS.nonMembersPrice, ValidationMessages.NON_MEMBER_PRICE_LOWER);
        } else {
          setFormError(FIELDS.nonMembersPrice, undefined);
        }
      } else {
        setFormError(FIELDS.nonMembersPrice, undefined);
      }
    } else {
      setNonMembersP('');
      handleValueChange(FIELDS.nonMembersPrice, '');
      
      // Clear non-member price error when field is empty
      setFormError(FIELDS.nonMembersPrice, undefined);
      
      // Check if member price exists, add error if needed
      if (membersPrice && membersPrice !== '$' && !exclusive) {
        setFormError(FIELDS.nonMembersPrice, ValidationMessages.NON_MEMBER_PRICE_LOWER);
      } else {
        setFormError(FIELDS.nonMembersPrice, undefined);
      }
    }
  };

  const handleContentChange = e => {
    setSelectedContent(e);
    handleValueChange(FIELDS.content_viewer_category, e.value);
  };

  // Add custom error setter function
  const setFormError = useCallback((field, error) => {
    setFormErrors(prev => ({
      ...prev,
      [field]: error ? [error] : undefined
    }));
  }, []);

  return (
    <div className="serie-landing" ref={ref}>
      <div className="serie-landing-header">
        {!editEpisodeData ? intl.formatMessage(messages.newEpisode) : 'Update Episode'}{' '}
        <Close onClick={hide} color={isMobile ? white : black40} />
      </div>
      <div className="serie-landing-header-content">
        <div className="series-form">
          <div className="series-form-fields">
            <Input
              name="seriesTitle"
              placeholder={intl.formatMessage(messages.nameYourEpisodePlaceholder)}
              label={intl.formatMessage(messages.title)}
              errors={errors[FIELDS.title]}
              {...inputProps(FIELDS.title)}
            />
            <Input
              name="seriesDescription"
              placeholder={intl.formatMessage(messages.descriptionEpisodePlaceholder)}
              label={intl.formatMessage(messages.description)}
              errors={errors[FIELDS.description]}
              {...inputProps(FIELDS.description)}
            />
            <Input
              name="seriesLeadCast"
              placeholder="Lead cast of the episode"
              label="Lead Cast (optional)"
              errors={errors[FIELDS.lead_cast]}
              {...inputProps(FIELDS.lead_cast)}
            />
            <Input
              name="seriesCredits"
              placeholder="Credits of the episode"
              label="Credits (optional)"
              errors={errors[FIELDS.credits]}
              {...inputProps(FIELDS.credits)}
            />
            <div
              className={cn('custom-content')}
              style={{ margin: `${isMobile ? '0 1.4rem 2.8rem' : ''}` }}
            >
              <span className="custom-content-label">Content Viewers</span>
              <div className="single-select">
                <Select
                  value={selectedContent}
                  options={contentOptions}
                  styles={customDropDownStyles}
                  onChange={handleContentChange}
                  isSearchable={false}
                />
              </div>
            </div>
            <input
              type="file"
              ref={seriesVideoRef}
              style={{ display: 'none' }}
              accept=".mp4,.mov"
              onChange={handleSeriesVideoChange}
              name="series_video"
            />
            <div className="input-container upload-div">
              <span className="tag-bold input-label">{intl.formatMessage(messages.video)}</span>
              {seriesVideo ? (
                <div>
                  {/* Only show video if we have valid seriesVideo data */}
                  {editEpisodeData ||
                  seriesVideo.originalFile instanceof Blob ||
                  typeof seriesVideo === 'string' ? (
                    <video className="video-preview" autoPlay>
                      <source
                        src={
                          editEpisodeData
                            ? seriesVideo
                            : seriesVideo.originalFile instanceof Blob
                            ? URL.createObjectURL(seriesVideo.originalFile)
                            : typeof seriesVideo === 'string'
                            ? seriesVideo
                            : ''
                        }
                        type="video/mp4"
                      />
                      Your browser does not support the video tag.
                    </video>
                  ) : (
                    <div className="video-preview-placeholder">
                      <p>Video selected: {seriesVideo.name || 'Unknown file'}</p>
                      <p>
                        Size:{' '}
                        {seriesVideo.size
                          ? `${(seriesVideo.size / (1024 * 1024)).toFixed(2)} MB`
                          : 'Unknown'}
                      </p>
                      <p>Duration: {seriesVideo.durationFormatted || '00:00:00'}</p>
                    </div>
                  )}
                  {isUploading && (
                    <div className="upload-progress">
                      <div className="progress-bar" style={{ width: `${uploadProgress}%` }}></div>
                      <span>{uploadProgress}%</span>
                    </div>
                  )}
                </div>
              ) : (
                <div className="button-margin">
                  <Button
                    labelId={intl.formatMessage(messages.chooseVideo)}
                    type="secondary"
                    onClick={handleSeriesVideoUpload}
                    className="cover-button"
                    disabled={isUploading}
                  />
                  <span className="label-margin">Recommended dimension: 1280px X 720px (16:9)</span>
                </div>
              )}
            </div>
            <Input
              name="creditStartTime"
              placeholder={intl.formatMessage(messages.hhmmssPlaceholder)}
              label={intl.formatMessage(messages.creditStartTime)}
              errors={errors[FIELDS.creditsStartTime]}
              {...inputProps(FIELDS.creditsStartTime)}
              maxLength={8}
              value={creditStartTime}
              onChange={onChangeCreditsStartTime}
            />
            <div className="input-container">
              <div className="form-group">
                <input type="checkbox" id="members" checked={exclusive} onChange={handleChecked} />
                <label htmlFor="members" className="tag-bold input-label">
                  Exclusive for Members
                  <span>
                    <CrownIcon width={20} height={20} />
                  </span>
                </label>
              </div>
            </div>
            {exclusive ? (
              <>
                <div className="input-container">
                  <div className="tag-bold input-label">
                    {intl.formatMessage(messages.releaseDateTimeLabel)}
                  </div>
                  <div className="input-card">
                    <div className="d-flex">
                      <Input
                        name="date"
                        type="date"
                        placeholder={intl.formatMessage(messages.date)}
                        label={intl.formatMessage(messages.date)}
                        value={values[FIELDS.releaseDate]}
                        onChange={handleReleaseDate}
                        min={getTodayDate()}
                      />
                      <Input
                        name="time"
                        placeholder="HH:MM"
                        label={intl.formatMessage(messages.time)}
                        errors={errors[FIELDS.releaseTime]}
                        {...inputProps(FIELDS.releaseTime)}
                        maxLength={5}
                        value={releaseTime}
                        onChange={onChangeReleaseTime}
                      />
                    </div>
                    <p style={{ cursor: 'pointer' }} onClick={handleClearEarlyReleaseDateTime}>
                      Clear
                    </p>
                    <small>*Leave it empty in order to be published right away.</small>
                  </div>
                </div>
                <div className="input-container">
                  <div className="tag-bold input-label">
                    {intl.formatMessage(messages.setPriceLabel)}
                  </div>
                  <div className={`input-card ${exclusive ? 'active' : ''}`}>
                    <div className="d-flex">
                      <Input
                        name="members"
                        placeholder="Price"
                        label={intl.formatMessage(messages.members)}
                        errors={errors[FIELDS.membersPrice]}
                        {...inputProps(FIELDS.membersPrice)}
                        onChange={onChangeMembersPrice}
                        value={membersPrice}
                      />
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="input-container">
                  <div className="tag-bold input-label">
                    {intl.formatMessage(messages.earlyReleaseMembers)}
                  </div>
                  <div className="input-card">
                    <div className="d-flex">
                      <Input
                        name="date"
                        type="date"
                        placeholder={intl.formatMessage(messages.date)}
                        label={intl.formatMessage(messages.date)}
                        value={values[FIELDS.earlyReleaseDate]}
                        onKeyDown={handleDateKeyDown}
                        onChange={handleEarlyReleaseDate}
                        min={getTodayDate()}
                      />
                      <Input
                        name="time"
                        placeholder="HH:MM"
                        label={intl.formatMessage(messages.time)}
                        errors={errors[FIELDS.earlyReleaseTime]}
                        {...inputProps(FIELDS.earlyReleaseTime)}
                        maxLength={5}
                        value={earlyReleaseTime}
                        onChange={onChangeEarlyReleaseTime}
                      />
                    </div>
                    <p style={{ cursor: 'pointer' }} onClick={handleClearEarlyReleaseDateTime}>
                      Clear
                    </p>
                  </div>
                </div>
                <div className="input-container">
                  <div className="tag-bold input-label">
                    {intl.formatMessage(messages.normalRelease)}
                  </div>
                  <div className="input-card">
                    <div className="d-flex">
                      <Input
                        name="date"
                        type="date"
                        placeholder={intl.formatMessage(messages.date)}
                        label={intl.formatMessage(messages.date)}
                        value={values[FIELDS.releaseDate]}
                        onKeyDown={handleDateKeyDown}
                        onChange={handleReleaseDate}
                        min={getTodayDate()}
                      />
                      <Input
                        name="time"
                        placeholder="HH:MM"
                        label={intl.formatMessage(messages.time)}
                        errors={errors[FIELDS.releaseTime]}
                        {...inputProps(FIELDS.releaseTime)}
                        maxLength={5}
                        value={releaseTime}
                        onChange={onChangeReleaseTime}
                      />
                    </div>
                    <p style={{ cursor: 'pointer' }} onClick={handleClearReleaseDateTime}>
                      Clear
                    </p>
                    <small>*Leave it empty in order to be published right away.</small>
                  </div>
                </div>
                <div className="input-container">
                  <div className="tag-bold input-label">
                    {intl.formatMessage(messages.setPriceLabel)}
                  </div>
                  <div className="input-card">
                    <div className="d-flex">
                      <Input
                        name="nonMembers"
                        placeholder="Price"
                        label={intl.formatMessage(messages.nonMembers)}
                        errors={formErrors[FIELDS.nonMembersPrice]}
                        {...inputProps(FIELDS.nonMembersPrice)}
                        onChange={onChangeNonMembersPrice}
                        value={nonMembersP}
                      />
                      <Input
                        name="members"
                        placeholder="Price"
                        label={intl.formatMessage(messages.members)}
                        errors={errors[FIELDS.membersPrice]}
                        {...inputProps(FIELDS.membersPrice)}
                        onChange={onChangeMembersPrice}
                        value={membersPrice}
                      />
                    </div>
                    <small>*Leave this field empty for free content.</small>
                  </div>
                </div>
              </>
            )}
            {!editEpisodeData && (
              <div className={cn('notify-box')}>
                <input
                  type="checkbox"
                  checked={subscribedFans}
                  onChange={() => {
                    setSubScribedFans(!subscribedFans);
                    handleValueChange(FIELDS.notify_subscribers, !subscribedFans);
                  }}
                />
                Notify all paid fans
              </div>
            )}
            <Button
              labelId={
                !editEpisodeData ? intl.formatMessage(messages.addEpisode) : 'Update Episode'
              }
              type="secondary"
              onClick={handleSubmit}
              className="in-add-button"
              disabled={
                some(errors) ||
                some(formErrors) ||
                !values[FIELDS.title] ||
                !values[FIELDS.description] ||
                !seriesVideo ||
                isUploading ||
                (seriesVideo?.isMultipart && (!seriesVideo.uploadId || !seriesVideo.mediaId))
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

AddEpisodeForm.propTypes = {
  hide: func.isRequired
};

export default AddEpisodeForm;
